import { ERROR_SET } from "./types";

export const setError = (text, level, history) => (dispatch) => {
  dispatch({
    type: ERROR_SET,
    payload: { text, level },
  });
  history.push("/alert/info?message=custom");
};
